"use strict";

var _classCallCheck = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _slicedToArray = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var channel_1 = require("./channel");

var constants_1 = require("./constants");

var filter_1 = require("./filter");

var units = [['m', 1], ['S', 1000], ['M', 60 * 1000], ['H', 60 * 60 * 1000]];

function getDeadline(deadline) {
  var now = new Date().getTime();
  var timeoutMs = Math.max(deadline - now, 0);

  for (var _i = 0; _i < units.length; _i++) {
    var _units$_i = _slicedToArray(units[_i], 2),
        unit = _units$_i[0],
        factor = _units$_i[1];

    var amount = timeoutMs / factor;

    if (amount < 1e8) {
      return String(Math.ceil(amount)) + unit;
    }
  }

  throw new Error('Deadline is too far in the future');
}

var DeadlineFilter =
/*#__PURE__*/
function (_filter_1$BaseFilter) {
  _inherits(DeadlineFilter, _filter_1$BaseFilter);

  function DeadlineFilter(channel, callStream) {
    var _this;

    _classCallCheck(this, DeadlineFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DeadlineFilter).call(this));
    _this.channel = channel;
    _this.callStream = callStream;
    _this.timer = null;
    var callDeadline = callStream.getDeadline();

    if (callDeadline instanceof Date) {
      _this.deadline = callDeadline.getTime();
    } else {
      _this.deadline = callDeadline;
    }

    var now = new Date().getTime();
    var timeout = _this.deadline - now;

    if (timeout < 0) {
      timeout = 0;
    }

    if (_this.deadline !== Infinity) {
      _this.timer = setTimeout(function () {
        callStream.cancelWithStatus(constants_1.Status.DEADLINE_EXCEEDED, 'Deadline exceeded');
      }, timeout);
      callStream.on('status', function () {
        return clearTimeout(_this.timer);
      });
    }

    return _this;
  }

  _createClass(DeadlineFilter, [{
    key: "sendMetadata",
    value: function sendMetadata(metadata) {
      var _this2 = this;

      if (this.deadline === Infinity) {
        return metadata;
      }

      return new Promise(function (resolve, reject) {
        if (_this2.channel.getConnectivityState(false) === channel_1.ConnectivityState.READY) {
          resolve(metadata);
        } else {
          var handleStateChange = function handleStateChange(newState) {
            if (newState === channel_1.ConnectivityState.READY) {
              resolve(metadata);

              _this2.channel.removeListener('connectivityStateChanged', handleStateChange);
            }
          };

          _this2.channel.on('connectivityStateChanged', handleStateChange);
        }
      }).then(function (finalMetadata) {
        var timeoutString = getDeadline(_this2.deadline);
        finalMetadata.set('grpc-timeout', timeoutString);
        return finalMetadata;
      });
    }
  }]);

  return DeadlineFilter;
}(filter_1.BaseFilter);

exports.DeadlineFilter = DeadlineFilter;

var DeadlineFilterFactory =
/*#__PURE__*/
function () {
  function DeadlineFilterFactory(channel) {
    _classCallCheck(this, DeadlineFilterFactory);

    this.channel = channel;
  }

  _createClass(DeadlineFilterFactory, [{
    key: "createFilter",
    value: function createFilter(callStream) {
      return new DeadlineFilter(this.channel, callStream);
    }
  }]);

  return DeadlineFilterFactory;
}();

exports.DeadlineFilterFactory = DeadlineFilterFactory;